import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/wind-chill-calculator',
  component: () => import('../../routes/WindChillCalculator.svelte'),
  card: {
    id: 'wind-chill-calculator',
    title: 'Wind Chill Calculator',
    description: 'Calculate the felt temperature based on actual temperature and wind speed using the NWS wind chill index formula.',
    icon: 'air',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/wind-chill-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Wind Chill Calculator – NWS Wind Chill Index',
    description: 'Free wind chill calculator using the official NWS 2015 formula. Calculate how cold it actually feels outside based on temperature and wind speed, with frostbite risk warnings.',
  },
};

export default meta;
